import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "x-cell-input-field"
};
const _hoisted_2 = {
  class: "label-text"
};
const _hoisted_3 = {
  class: "field-input-border"
};
import TableCell from './tableCell.vue';
import { computed } from 'vue';
export default {
  __name: 'cellInputField',
  props: {
    label: {
      type: String,
      default: '标题'
    },
    labelWidth: {
      type: [String, Number],
      default: '60px'
    }
  },
  setup(__props) {
    const props = __props;
    const labelStyle = computed(() => {
      if (typeof props.labelWidth === 'undefined') {
        return {
          width: '60px'
        };
      }
      const lWidth = typeof props.labelWidth === 'number' ? `${props.labelWidth}px` : props.labelWidth;
      return {
        width: lWidth
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(TableCell, null, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createElementVNode("span", {
          class: "field-label",
          style: _normalizeStyle(labelStyle.value)
        }, [_createElementVNode("span", _hoisted_2, [_renderSlot(_ctx.$slots, "label", {}, () => [_createTextVNode(_toDisplayString(__props.label), 1)])])], 4), _createElementVNode("span", _hoisted_3, [_renderSlot(_ctx.$slots, "default")])])]),
        _: 3
      });
    };
  }
};